import { ActionFunction, redirect } from 'react-router-dom';
import { client } from '~/api/client';
import { mutateData } from '~/api/data/request';
import { submitMutation } from '~/api/data/responses';
import {
  CreateAgencyProfileDocument,
  CreateAgencyProfileMutation,
  CreateAgencyProfileMutationVariables,
  UpdateAgencyProfileDocument,
  UpdateAgencyProfileMutation,
  UpdateAgencyProfileMutationVariables
} from '~/api/graphql';

export const createAgencyProfile = (variables: CreateAgencyProfileMutationVariables) =>
  mutateData<CreateAgencyProfileMutation, CreateAgencyProfileMutationVariables>(client, {
    mutation: CreateAgencyProfileDocument,
    variables
  });

export const updateAgencyProfile = (variables: UpdateAgencyProfileMutationVariables) =>
  mutateData<UpdateAgencyProfileMutation, UpdateAgencyProfileMutationVariables>(client, {
    mutation: UpdateAgencyProfileDocument,
    variables
  });

export const submitCreateAgencyProfile: ActionFunction = async ({ request }) =>
  submitMutation(createAgencyProfile({ input: await request.json() }), async (data) =>
    redirect(`/app/settings/access-profiles/${data?.createAgencyProfile?.id}`)
  );

export const submitUpdateAgencyProfile: ActionFunction = async ({ params, request }) =>
  submitMutation(updateAgencyProfile({ id: params.id || '', input: await request.json() }));
